import store from "@/store";
import {grantAccessToApplication} from "@/services/ApplicationService";
import router from "@/core/router";
import {useGrants} from "@/services/grantsService";

export async function missingAccessToApplicationModal(application, onCancel, onLogout) {
    const vue = router.app;
    const email = store.getters['Auth/user'].email;
    const appName = application.name;
    const isGranted = await useGrants();

    return vue.$swal({
        icon: 'error',
        title: vue.$t('auth.no_access_to_application_title', {appName}),
        text: vue.$t('auth.no_access_to_application_text', {email, appName}),
        showConfirmButton: isGranted('$gd.service'),
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: vue.$t('auth.no_access_to_application_grant_access_button'),
        denyButtonText: vue.$t('auth.no_access_to_application_logout_button'),
        cancelButtonText: vue.$t('auth.no_access_to_application_no_button'),
        customClass: {
            confirmButton: 'btn btn-success btn-lg',
            denyButton: 'btn btn-primary btn-lg',
            cancelButton: 'btn btn-link btn-lg'
        }
    }).then((result) => {
        if (result.isDenied) {
            return store.dispatch('Auth/logout').then(() => onLogout());
        }

        if (result.isConfirmed) {
            return grantAccessToApplication(application.uuid)
        }

        return onCancel();
    });
}